import Button from "../../buttons/Button.tsx";
import {ButtonSize, ButtonVariant} from "../../../types/button.ts";
import {ChevronLeftIcon} from "@heroicons/react/24/outline";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {useAppDispatch, useAppSelector} from "../../../stores/store.ts";
import {epgDetailsActions} from "./epgDetailsSlice.ts";
import DateHelper from "../../../helpers/dateHelper.ts";
import {IPlayerChannel} from "../../../interfaces/player/IPlayerUIState.ts";
import {useModal} from "../../../hooks/useModal.tsx";

interface IProps {
    channels: IPlayerChannel[]
}

const EpgDetailsNextEpisodeComingView = ({channels}: IProps) => {
    const epgDetails = useAppSelector(store => store.epgDetails);
    return (
        <div className={"modal-opacity-ease-in-out-animation p-3 pt-0 h-full flex flex-col"}>
            {epgDetails.nextEpisodeComing.length > 0 &&
                <p className={"text-base mt-4 mb-2 px-3 text-sky-500 font-bold tracking-wider"}>
                    {epgDetails.category &&
                    epgDetails.category
                        .toLowerCase()
                        .includes("odc") || epgDetails.category.toLowerCase().includes("serial") || epgDetails.category.toLowerCase().includes("odc.")
                        ? "Więcej odcinków:"
                        : "Powtórki programu:"}{" "}
                </p>}
            <div
                className={"flex-1 flex flex-col overflow-hidden bg-neutral-700 border-t border-neutral-600"}>
                <div
                    className={"flex flex-col text-sm overflow-y-auto min-h-0 p-3 py-4 rounded-3xl border-t-0 border-neutral-500 pt-3 pb-3"}>
                    {epgDetails.nextEpisodeComing.length > 0 &&
                        [...epgDetails.nextEpisodeComing]
                            .sort((a, b) => {
                                return a.time.localeCompare(b.time);
                            })
                            .map((epgitem, index) =>
                                    <span className={"flex flex-col space-y-1"} key={index}>
                            {index !== 0 &&
                                <span className={"w-full h-px bg-neutral-600 my-2"}/>
                            }
                                        <span
                                            className={"flex justify-between text-neutral-400"}
                                        >
                                <span className={""}>
                                    {DateHelper.DateTimeFormatForEpgDetails(new Date(epgitem.time))}
                                </span>
                                <span className={""}>
                                    {/* TODO */}
                                    {/* <pre>{JSON.stringify(epgitem)}</pre> */}
                                    {channels.find((x) => x.ch_id === epgitem.channelId)?.name}
                                </span>
                            </span>
                            <span className={"truncate text-neutral-200"}>
                                {epgitem.name}
                            </span>
                        </span>
                            )
                    }
                </div>
                {epgDetails.nextEpisodeComing.length <= 0 &&
                    <span className={"truncate text-neutral-300 text-center"}>
                        Brak podobnych programów w przyszłości
                    </span>
                }
            </div>
        </div>
    );
};

export default EpgDetailsNextEpisodeComingView;